import { render, staticRenderFns } from "./DialogAlert.vue?vue&type=template&id=3b5c8f34"
import script from "./DialogAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogAlert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports